<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><span class="center"><a id="page-2"></a><em>For Dave Duncan, a scholar, a gentleman,<br/> and a damned fine writer.<br/> Thanks for all the fabulous reads—and lunch.<br/> Here’s to many more!</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface004.vue?7a21871e